import { Creators as TokenActions } from '../store/ducks/token'
import { Creators as UserActions } from '../store/ducks/user'

import { store } from '../store'

export function logout() {
	store.dispatch(TokenActions.resetToken())
	store.dispatch(UserActions.resetUser())
}
